import { assertPerson, deadBy, expectedDeathYear, getEstimatedExpenseSwitchoverDate, IRetirementPerson, Profile, retirementDate, retirementYear } from 'app/redux/Profile/model'
import * as _ from 'lodash'
import * as moment from 'moment'

// describe some virtual points in time (relative to a profile and possibly a person)
enum AbstractWhen { // the enum values can NOT change without repairing the database!!!
  initial = 'initial',

  // related to the member
  memberDeath = 'memberDeath',
  memberSSABegin = 'memberSSABegin',

  // related to some person
  personDeath = 'personDeath',
  //personSSABegin = 'personSSABegin',

  // related to the spouse
  spouseDeath = 'spouseDeath',
  spouseSSABegin = 'spouseSSABegin',

  // whenever the first person dies
  firstPersonDying = 'firstPersonDying',

  // whenever the last person dies
  lastPersonDying = 'lastPersonDying',

  // the expense switchover date
  expenseSwitchover = 'expenseSwitchover'
}

/**
 * Return the actual date that corresponds to an abstract date.
 *
 * @param when - the date abstraction requested
 * @param profile - the profile object to reference
 * @param person - if a meta-when (person, not specific member or spouse), this is the person to use
 *
 * @returns The corresponding date and the person [most] associated with that date.
 */
function getDateOf(abstractWhen: AbstractWhen, profile: Profile, person?: IRetirementPerson) {
  const member = profile.getHeadOfHousehold()
  const spouse = profile.getSpouse()

  switch (abstractWhen) {
    case AbstractWhen.memberDeath:
      assertPerson(member)
      return { abstractWhen, when: deadBy(member), person: member }

    case AbstractWhen.memberSSABegin:
      assertPerson(member)
      return { abstractWhen, when: retirementDate(member), person: member }

    case AbstractWhen.spouseDeath:
      assertPerson(spouse)
      return { abstractWhen, when: deadBy(spouse), person: spouse }

    case AbstractWhen.spouseSSABegin:
      assertPerson(spouse)
      return { abstractWhen, when: retirementDate(spouse), person: spouse }

    case AbstractWhen.personDeath:
      assertPerson(person)
      return { abstractWhen, when: deadBy(person), person }

      /*
    case AbstractWhen.personSSABegin:
      assertPerson(person)
      return { abstractWhen, when: retirementDate(person), person }
      */

    case AbstractWhen.firstPersonDying:
      const fp = firstPersonDying(profile.getImportantPeople())
      assertPerson(fp)
      return { abstractWhen, when: deadBy(fp), person: fp }

    case AbstractWhen.lastPersonDying:
      const lp = lastPersonLiving(profile.getImportantPeople())
      assertPerson(lp)
      return { abstractWhen, when: deadBy(lp), person: lp }

    case AbstractWhen.expenseSwitchover:
      return { abstractWhen, when: getEstimatedExpenseSwitchoverDate(profile), person: member }

    default:
      throw new Error('getDateOf- unsupported AbstractWhen: ' + abstractWhen)
  }
}

function firstPersonDying(people: IRetirementPerson[]): IRetirementPerson {
  return _(orderedByDeath(people)).first()
}

function firstPersonRetiring(people: IRetirementPerson[]): IRetirementPerson {
  return _(orderedByRetirement(people)).first()
}

function lastPersonLiving(people: IRetirementPerson[]): IRetirementPerson {
  return _(orderedByDeath(people)).last()
}

function lastPersonRetiring(people: IRetirementPerson[]): IRetirementPerson {
  return _(orderedByRetirement(people)).last()
}

function orderedByDeath(people: IRetirementPerson[], ordering: _.Many<string | boolean> = 'asc'): IRetirementPerson[] {
  return _(people)
    .orderBy(expectedDeathYear, ordering)
    .value()
}

function orderedByRetirement(people: IRetirementPerson[], ordering: _.Many<string | boolean> = 'asc'): IRetirementPerson[] {
  return _(people)
    .orderBy(retirementYear, ordering)
    .value()
}

export {
  AbstractWhen,

  firstPersonDying,
  firstPersonRetiring,
  getDateOf,
  lastPersonLiving,
  lastPersonRetiring,
  orderedByDeath,
  orderedByRetirement
}



// WEBPACK FOOTER //
// ./src/app/calcs/predicates.ts